export const reg_phone = /^1[345789]\d{9}$/

export function phoneValid4El(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入手机号码'));
  } else if (value != '' && !(reg_phone.test(value))) {
    callback(new Error('请输入正确的手机号码'));
  } else {
    callback();
  }
}